<template>
    <!-- Invite accounts for super user page -->
    <div class="add-new-client">
        <md-dialog :md-active.sync="showDialog" >          
          <md-dialog-title>
              <span>{{ title }}</span>
              <button class="btn btn--close" @click="cancel"></button>
          </md-dialog-title>
          <validation-observer v-slot="{ handleSubmit }" tag="div">
            <form @submit.prevent="handleSubmit(inviteAccount)" class="form">
            <div class="form__content">                           
              <ValidationProvider rules="required" v-slot="{ errors }">
                    <md-field>
                      <md-icon v-if="error.height" class="md-accent">warning</md-icon>
                      <label>Creative Company</label>
                      <md-select v-model="account.creative_company_id" >
                        <md-option v-for="c in creative_companies" :key="c.id" :value="c.id">{{c.name}}</md-option>
                      </md-select>
                    </md-field>
                    <div class="form__error">{{ errors[0] }}</div>

                  </ValidationProvider>
              <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                
                  <md-field>                        
                    <label style="text-transform: capitalize;">{{ type }} name</label>
                    <md-input v-model="account.name" />
                  </md-field>
                  <div class="form__error">{{ errors[0] }}</div>
              </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
                  <md-field>                      
                    <label style="text-transform: capitalize;">{{ type }} e-mail</label>
                    <md-input v-model="account.email" />
                  </md-field>
                  <div class="form__error">{{ errors[0] }}</div>
                </ValidationProvider>                          
            </div>
            <md-dialog-actions>
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                </div>
                <div class="md-layout-item text-right">
                 <md-button class="md-primary modal-save-btn" type="submit">Send Invation</md-button>
                </div>
              </div>
            </md-dialog-actions>
            </form>
          </validation-observer>
        </md-dialog>
            
        <button class="md-button btn newClientButton md-theme-default" @click="showDialog = true">
            <img alt="Add Button" class="addButton" src="@/assets/img/icons/addButton.svg" />
            add new {{ type }}
        </button>
    </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';


setInteractionMode('eager');
extend('required', {
  ...required,
  message: "The field is required."
});

export default {
  
  mixins: [apiHandlerMI],
  props: ['creative_companies','title','type'],
  data(){
    return{
      showDialog: false,
      active: false,
      account: {
        name: '',
        email: ''
      },
      error: {},      
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  mounted(){
   // console.log(this.creative_companies);
  },

    methods:{
      
      inviteAccount(){
        var _this = this;
        _this.account.type = _this.type;
        _this.post('usermanager/invite'+_this.type,_this.account,{},function(resp){
            var user = resp.data.user;
            _this.post('emailsender/1/1',{
                to: user.email,
                data_replace:{
                    url: "http://localhost:8080/",
                    sender_user: _this.$store.state.user.name,
                    name: user.name,
                    token: user.token
                }
            },{},function(){
               _this.$emit('refreshAccounts');
                if (_this.$parent.refreshAccounts)
                 _this.$parent.refreshAccounts();
                 if (_this.$parent.refreshDesigner)
                 _this.$parent.refreshDesigner();
                 _this.showDialog = false
            })
        },function(err){
          console.log(err)
            alert('Valami nem sikerült ellenőrizd az adatokat!');
        })
      },
      
      cancel(){
        this.showDialog = false        
      }
    }
 }

</script>